import React, { useState, useEffect, useCallback } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { LineChart } from "@mui/x-charts/LineChart";

import { getDashboard_ } from "store/services/dashboardService";

export default ({
  dashboardList,
  dispatch,
  selectedInterval1,
  setSelectedInterval1,
  userData,
  setuserData,
}) => {
  // console.log(userData)

  const currentYear = new Date().getFullYear();
  const futureYears = Array.from(
    { length: 5 },
    (_, index) => currentYear + index
  );
  const data = {
    monthly: selectedInterval1 === "monthly" && {
      uData:
        userData?.response?.length > 0 ? userData?.response : Array(12).fill(0),
      xLabels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    weekly: selectedInterval1 === "weekly" && {
      uData:
        userData?.response?.length > 0 ? userData?.response : Array(7).fill(0),
      xLabels: Array.from({ length: 7 }, (_, index) => `${index + 1}`),
    },
    yearly: selectedInterval1 === "yearly" && {
      uData:
        userData?.response?.length > 0
          ? userData?.response
          : Array(futureYears.length).fill(0),
      xLabels: futureYears.length > 0 ? futureYears.map(String) : [],
    },
    daily: selectedInterval1 === "daily" && {
      uData:
        userData?.response?.length > 0 ? userData?.response : Array(31).fill(0),
      xLabels: Array.from({ length: 31 }, (_, index) => `${index + 1}`),
    },
  };

  const handleIntervalChange_ = async (e) => {
    try {
      setSelectedInterval1(e.target.value);
      let query = {
        filter: e.target.value,
        type: "user",
      };
      setuserData({ response: "" });
      let res = await dispatch(getDashboard_(query));
      if (res) {
        setuserData({ response: res?.data?.data?.userData?.response });
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card graph_card p-0">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-md-6">
                  <label for="exampleInputName1">
                    <b>New Clients</b>
                  </label>
                </div>
                <div className="col-md-6">
                  <div className="selector_fillter d-flex gap-3 align-items-center">
                    <div class="filter_drop_filter">
                      <select
                        className="form-select filler_search"
                        value={selectedInterval1}
                        name="interval"
                        onChange={(e) => handleIntervalChange_(e)}
                      >
                        <option value="" disabled selected>
                          {" "}
                          Select Interval{" "}
                        </option>
                        <option
                          value="daily"
                          selected={
                            selectedInterval1 === "daily" ? "selected" : ""
                          }
                        >
                          Daily
                        </option>
                        <option
                          value="weekly"
                          selected={
                            selectedInterval1 === "weekly" ? "selected" : ""
                          }
                        >
                          Weekly
                        </option>
                        <option
                          value="monthly"
                          selected={
                            selectedInterval1 === "monthly" ? "selected" : ""
                          }
                        >
                          Monthly
                        </option>
                        <option
                          value="yearly"
                          selected={
                            selectedInterval1 === "yearly" ? "selected" : ""
                          }
                        >
                          Yearly
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {userData?.response?.length > 0 && data[selectedInterval1] && (
                <LineChart
                  height={410}
                  series={[
                    {
                      data: data[selectedInterval1].uData,
                      color: "#e77476",
                      label: "New Clients",
                      area: true,
                    },
                  ]}
                  xAxis={[
                    {
                      data: data[selectedInterval1].xLabels,
                      scaleType: "band",
                    },
                  ]}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
